/**
 * Node Modules
 */
import React, {useState, createElement} from 'react'
import { Helmet } from 'react-helmet'
import { graphql, Link } from 'gatsby'
import marksy from 'marksy/jsx'

/**
 * Application Modules
 */
import PageContainer from '../../components/page-container'
import Metadata from '../../components/metadata'
import Footer from '../../components/footer'

import DownloadBanner from '../../components/download-banner'
import Section from '../../components/section'
import Spacer, {AspectSpacer} from '../../components/spacer'
import Header from '../../components/header'
import {HeroPrimary, HeroTertiary, CopyPrimary, CopySecondaryDiv} from '../../components/typography'
import './style.css'

  const styles = {
    '--logo-color': 'var(--purple)',
    '--color': 'var(--light-purple)',
    '--active-color': 'var(--coral)',
    '--background-color': 'var(--white)',
  }

const compile = marksy({createElement})

function ContactForm ({hed, dek, name, message, under13Message, cta}) {
  const [isChild, setIsChild] = useState(true)

  return (
    <Section className='get-involved-contact-form contact-form'>
      <Helmet>
        <meta name="referrer" content="origin" />
      </Helmet>
      <div className="contact-form__grid grid">
        <div className="contact-form__content column-start-1 column-start-2--t  column-start-3--d column-end-6 column-end-11--t column-end-10--d">

          <HeroTertiary className="text-center">{hed}</HeroTertiary>
          <Spacer size={[10, 40]} />
          <CopySecondaryDiv className="text-center">{compile(dek).tree}</CopySecondaryDiv>
          <Spacer size={[20, 40]} />
          <form action="https://formspree.io/hello@kinzoo.com" method="POST">
            <input type="hidden" name="_subject" value="Website Contact Form" />
            <div className="contact-form__age-radio-group flex flex-center">
              <span>Age:</span>
              <label><input className="contact-form__radio" checked={isChild ? 'checked' : ''} onChange={() => {setIsChild(true)}} name="age-check" value="under 13" type='radio'/><span>under 13</span></label>
              <label><input className="contact-form__radio" checked={!isChild ? 'checked' : ''} onChange={() => {setIsChild(false)}} name="age-check" value="13 and older" type='radio'/><span>13 and older</span></label>
            </div>
            <Spacer size={[20, 30]} />
            {!isChild && <>
              <input className="contact-form__input reset" type="text" name="name" placeholder={name} />
              <Spacer size={[20, 30]} />
              <input className="contact-form__input reset" type="text" name="_replyto" placeholder="Email address"/>
              <Spacer size={[20, 30]} />
            </>}
            {isChild && <>
              <input className="contact-form__input reset" type="hidden" name="name" value="Child under 13" />
              <input className="contact-form__input reset" type="hidden" name="_replyto" value="no-reply@kinzoo.com"/>{/* Zendesk+formspree requires an email */}
            </>}
            <div className="contact-form__textarea-group">
              <textarea className="contact-form__textarea reset" name="message" placeholder={isChild ? under13Message: message } />
              <Link className="contact-form__privacy-policy contact-form__privacy-policy--purple contact-form__privacy-policy--not-mobile" to="/privacy-policy">Privacy Policy</Link>
            </div>
            <Spacer size={[10, 40]} />
            <div className="flex flex-center">
              <input className='button contact-form__submit reset' type="submit" value={cta} />
            </div>
            <Spacer size={[10, 0]} />
            <Link className="contact-form__privacy-policy contact-form__privacy-policy--purple contact-form__privacy-policy--mobile" to="/privacy-policy">Privacy Policy</Link>
            <Spacer size={[55, 86]} />
          </form>
        </div>
      </div>
    </Section>
  )
}

function KeyValue({ className, hed, dek, links, img, alt }) {
  console.log(links, !!links &&links.length > 0)
  return (
    <Section className={`charter-key-value ${className || ''}`}>
      <div className="charter-key-value__grid grid">
        <div
          className="column-start-1 column-end-6 column-end-5--t flex flex-center"
          style={{ textAlign: 'center' }}
        >
          <img src={img} alt={alt} className="charter-key-value__image" />
        </div>

        <div className="column-start-1 column-end-6 column-start-6--t column-end-11--t  column-end-10--d  flex flex-center">
          <div>
            <h2 className="charter-key-value__hed">
              {hed}
            </h2>
            <p className="charter-key-value__dek">
              {compile(dek).tree}
            </p>
            <div className="charter-key-value__anchor-group">
              {(!!links && links.length > 0) && links.map(link => (
                <a className="button button--yellow" key={link.href} href={link.href}>
                  {link.text}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}


/**
 * Page Component
 */
export default function Page({ data }) {
  const {
    referencePageMetadata,
    hed,
    dek,
    hedA,
    hedB,
    hedC,
    dekA,
    dekB,
    dekC,
    linksA,
    linksB,
    linksC,
    contactHed,
    contactDek,
    contactNamePlaceholder,
    contactMessagePlaceholder,
    contactMessageUnder13Placeholder,
    contactCta
  } = data.contentfulSingletonGetInvolved

  return (
    <PageContainer>
      <Helmet>
        <link rel="canonical" href="https://kinzoo.com/get-involved/" />
        <meta property="og:url" content="https://kinzoo.com/get-involved/" />
      </Helmet>
      <Metadata {...referencePageMetadata} />
      <Header styles={styles} />
      <Section className="get-involved-hero" styles={styles} >
        <Spacer size={[50, 100]} />
        <div className="get-involved-hero__copy grid">
          <HeroPrimary className="text-center get-involved-hero__hed column-start-1 column-start-2--t column-start-3--d column-end-6 column-end-11--t column-end-10--d">{hed}</HeroPrimary>
          <Spacer className="column-start-1 column-end-6" size={[10, 40]} />
          <CopyPrimary className="text-center get-involved-hero__dek column-start-1 column-start-2--t column-start-3--d column-end-6 column-end-11--t column-end-10--d">{dek.dek}</CopyPrimary>
          <Spacer className="column-start-1 column-end-6" size={[40, 80]} />
        </div>
      </Section>

      <div className="get-involved get-involved__top-items">
        <KeyValue
          hed={hedA}
          dek={dekA.dekA}
          img={'/get-involved/image-a.png'}
          links={linksA}
          className="first"
        />
        <Spacer size={[54, 90]} />
      </div>    
      <div className="get-involved get-involved__bottom-items">
        
          <KeyValue
            hed={hedB}
            dek={dekB.dekB}
            links={linksB}
            img={'/get-involved/image-b.png'}
            className="charter-key-value charter-key-value--unpadded"
          />
          <Spacer id="press" size={[54, 90]} />
          <KeyValue
            hed={hedC}
            dek={dekC.dekC}
            links={linksC}
            img={'/get-involved/image-c.png'}
            className="last charter-key-value"
          />
          <Spacer id="contact" size={[43, 25]} />
          <AspectSpacer id="contact" size={[[1125,240],[3840,429]]} />
      </div>
      <ContactForm hed={contactHed} dek={contactDek.contactDek} name={contactNamePlaceholder} message={contactMessagePlaceholder} under13Message={contactMessageUnder13Placeholder} cta={contactCta} />

      <DownloadBanner />
      <Footer />
    </PageContainer>
  )
}

export const pageQuery = graphql`
  query GetInvolvedPageQuery {
    contentfulSingletonGetInvolved(contentful_id: {eq: "TT8Ke6gjNNykDz2sJdzv5"}) {
      referencePageMetadata {
        pageTitle
        ogTitle
        twitterTitle
        description
        ogDescription
        twitterDescription
        ogImage {
          file {
            url
          }
        }
        twitterImage {
          file {
            url
          }
        }
      }

      
      hed
      dek { dek }
      
      
      hedA
      dekA { dekA }
      linksA { text href }
      
      hedB
      dekB { dekB }
      linksB { text href }
      
      hedC
      dekC { dekC }
      linksC { text href }
      
      contactHed
      contactDek { contactDek }
      
      contactNamePlaceholder
      contactMessagePlaceholder
      contactMessageUnder13Placeholder
      contactCta
      
    }
  }
`
